export default {"src":"/_next/static/media/instagram.2fe68ed9.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};